import { render } from "./TheFooter.vue?vue&type=template&id=2956d68a&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=2956d68a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2956d68a"

export default script